import { DropDownMenu, MenuOne, OutlinePrimaryBtn, SidemenuClose, SolidPrimarySubBtn } from "components/button/Button";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { aesCBCDecrypt, APPSTORE_URL, GOOGLESTORE_URL, ROLE_DIRECTOR } from "utils/commonUtils";
import { adminLogout, removeStorage } from "api/api";
import AISCHOOLLOGO from "assets/image/common/aischool_logo.png";
import AISCHOOLICON from "assets/image/common/aischool_icon.ico";
import InvitationIcon from "assets/image/common/invitation.svg";
import {useLoginUserInfo} from "../../redux/hook/useLoginUserInfo";
import { EllipsisTextColumn } from "./Layout";
import { FlexWrapC, FlexWrapR } from "components/common/CommonLayout";
import { colors } from "styles/global-styles";
import { MiniModalComponent, ShortModalPropsInterface } from "components/ModalComponent";
import { QRCodeCanvas } from "qrcode.react";

export const VERSION = process.env.REACT_APP_VERSION;

const AppVersion = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    padding: 1rem;
    gap: 1rem;
    position: relative;

    > div:not(.download-btn-wrap) {
        width: 50%;
    }
`;
const Version = styled.div`
    color: ${({ theme }) => theme.newTheme.default.primary};
    text-align: center;
`;
const DownLoadAppBtnWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    position: absolute;
    top: -70px;
    right: 1.25rem;
    z-index: 1;
`;
const QrImageWrap = styled.div`
    width: 100%;
    height: 100%;
    background: url(${InvitationIcon}) center / contain no-repeat;
`;
const QrImage = styled.div`
    text-align: center;
    margin-top: 4rem;
    margin-left: 6px;
`;
const SidemenuContainer = styled.div`
    display: flex;
    flex-direction: row;
    &.sidemenu-container-open {
        section {
            width: 16.25rem;
        }
    }
    &.sidemenu-container-close {
        section {
            width: 5.5rem;
        }
    }
    section {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        &:first-of-type {
            background-color: ${({theme}) => theme.rootWhite};
        }
        &:last-of-type {
            width: 1.5rem;
            justify-content: center;
            &:hover {
                cursor: pointer;
            }
        }
    }
    article {
        width: 100%;
    }
    article.logo-wrap {
        height: 5rem;
        
        div {
            width: 100%;
            height: 100%;
        }

        img {
            display: inline-block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
        &:hover {
            cursor: pointer;
        }
    }
    article.profile-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > div {
            display: flex;
            align-items: center;
            flex-direction: row;
            gap: 0.25rem;
        }
        .my-menu-wrap {
            position: relative;
            img {
                vertical-align: middle;
            }
            &:hover {
                cursor: pointer;
                background-color: ${colors.lightGray};
            }
        }
        .my-menu {
            position: absolute;
            top: 2rem;
            display: flex;
            flex-direction: column;
            width: 10rem;
            background-color: white;
            border-radius: 0.5rem;
            box-shadow: 0 0 8px 0 rgb(0, 0, 0, 18%);
            z-index: 21;
            button {
                padding: 1rem;
                color: ${colors.darkGray};
                &:hover {
                    background-color: ${colors.lightGray};
                }
            }
        }
    }
    article.menu-wrap {
        height: 100%;
        overflow: auto;
        padding: 1rem;
        nav {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
        }
    }
`;

const ImageContainer = styled.div`
  aspect-ratio: 1 / 1;
  max-width: 7.5rem;
  max-height: 7.5rem;
  padding: 1rem;
  
  img {
      width:100%;
      height:100%;
      object-fit: cover;  /* 이미지 크기가 컨테이너를 완전히 덮도록 조정 */
      object-position: center;  /* 이미지 중앙에 배치 */
      border-radius: 50%;
      aspect-ratio: 1 / 1;
  }
`
const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  padding: 0.5rem;
  .ellipsis-text-wrap {
    width: calc(100% - 2rem);
  }
`;


function SideMenu() {
  
    const navigate = useNavigate();

    const { user, userMainImageUrl, updateLogoutUserInfo } = useLoginUserInfo();
    
    // 내정보 div
    const menuRef = useRef<HTMLDivElement>(null);

    // 사이드메뉴 펼침/접음
    const [isSideMenuClose, setIsSideMenuClose] = useState(false);
    // 내정보
    const [isMyMenuClose, setIsMyMenuClose] = useState(false);
    // 앱 다운로드
    const [isClickDownload, setIsClickDownload] = useState(false);

    //모달 상태
    const [modalProps, setModalProps] = useState<ShortModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        type: ""
    });

  //모달 열기 버튼 클릭 시
    const openModal = (text: string) => {
        let title = `${text} 다운로드`;
        let content:JSX.Element = <></>;

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title,
            content: content,
            type: text
        });
    }
  
    //QR코드 모달 컨텐츠
    const shortModalContent = (): JSX.Element => {

        // QR코드 생성
        const CreateQrCode = (): JSX.Element => {
            return (
                <QrImage>
                    <QRCodeCanvas
                        value={modalProps.type === "Google Play" ? GOOGLESTORE_URL : APPSTORE_URL}
                        level="M"
                        size={150}
                        marginSize={1}
                        imageSettings={{src: AISCHOOLICON, width: 40, height: 40, excavate: true }}
                    />
                </QrImage>
            )
        }

        // 구글스토어
        const googleAppDownload = () => {
            window.open(GOOGLESTORE_URL, '_blank');
        }
        // 앱스토어
        const iosAppDownload = () => {
            window.open(APPSTORE_URL, '_blank');
        }

        return (
            <FlexWrapC $gap="1rem" $alignItems="center" style={{height: '100%'}}>
                <QrImageWrap>
                    <CreateQrCode />
                </QrImageWrap>
                <OutlinePrimaryBtn onClick={modalProps.type === "Google Play" ? googleAppDownload : iosAppDownload}>{modalProps.type} 다운로드</OutlinePrimaryBtn>
            </FlexWrapC>
        )
    }

    // 사이드메뉴 접은 상태에서 아이콘부분 클릭 시 사이드메뉴 펼침
    function isClickIcon(prop: boolean) {
        setIsSideMenuClose(prop);
    }

    // 다른 영역 클릭 시 메뉴창 닫기
    const handleOutsideClick = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) setIsMyMenuClose(false);
    }

    // 로그아웃
    async function logoutUser() {

        const result = await adminLogout();

        if (result.code !== 200) {
            alert(result.message);
            return false;
        }

        // localStorage/로그인 정보 삭제
        removeStorage();
        return true;
    }

    const handleLogout = async () => {
        const success = await logoutUser(); // 로그아웃 함수 호출
        if (success) {
            updateLogoutUserInfo();
            navigate('/login'); // 로그아웃 성공 후 로그인 페이지로 이동
        }
    };

    useEffect(() => {
        document.addEventListener('mouseup', handleOutsideClick);
        return () => document.removeEventListener('mouseup', handleOutsideClick);
    }, []);

    return (
        <SidemenuContainer className={`${isSideMenuClose ? "sidemenu-container-close" : "sidemenu-container-open"}`}>
            <section>
                {/* 로고 */}
                <article className="logo-wrap" style={{padding: `${isSideMenuClose ? '1rem' : '1.5rem'}`}}>
                    {isSideMenuClose ?
                        <div onClick={() => navigate("/")}>
                            <img src={AISCHOOLICON} alt="icon" style={{borderRadius: '20%'}} />
                        </div>
                        :
                        <div onClick={() => navigate("/")}>
                            <img src={AISCHOOLLOGO} alt="logo" />
                        </div>
                    }
                </article>
                {/* 선생님 이미지 */}
                <article className="profile-wrap">
                    <ImageContainer>
                        <img src={userMainImageUrl} alt="default-profile"/>
                    </ImageContainer>
                    <UserInfoContainer>
                        {!isSideMenuClose && (
                        <FlexWrapR $alignItems="center" $justifyContent="center" className="ellipsis-text-wrap">
                            <EllipsisTextColumn>{aesCBCDecrypt(user.name)}</EllipsisTextColumn>
                            <p>
                                {user.role === "ROLE_DIRECTOR" ? " 관리자"
                                    : user.role === "ROLE_TEACHER" ? " 선생님" : " 학부모"}
                            </p>
                        </FlexWrapR>
                        )}
                        <div className="my-menu-wrap" onClick={() => setIsMyMenuClose((prev) => !prev)}>
                            <img src="/image/icon/arrow_fill_down.svg" alt="arrow-fill-down" />
                            {isMyMenuClose && (
                                <nav ref={menuRef} className="my-menu">
                                    <button type="button" onClick={() => navigate("/setting/profile")}>내 정보 수정</button>
                                    {/* <NavLink to="/switch-center">원 전환</NavLink> */}
                                    <button type="button" onClick={handleLogout}>로그아웃</button>
                                </nav>
                            )}
                        </div>
                    </UserInfoContainer>
                </article>
                <article className="menu-wrap">
                    {isSideMenuClose ? (
                        <nav>
                            <SidemenuClose icon="Board" linkTo="/" clickIcon={isClickIcon} />
                            <SidemenuClose
                                icon="Note"
                                linkTo="/notebook"
                                clickIcon={isClickIcon}
                            />
                            <SidemenuClose
                                icon="Notice"
                                linkTo="/notice"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Photo"
                                linkTo="/photo"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Calendar"
                                linkTo="/studentAttendance"
                                clickIcon={isClickIcon}
                            />
                            <SidemenuClose
                                icon="List"
                                linkTo="/list"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Bus"
                                linkTo="/bus"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Bread"
                                linkTo="/bread"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Temperature"
                                linkTo="/temperature"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Medicine"
                                linkTo="/medicine"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Home"
                                linkTo="/home"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Money"
                                linkTo="/receipt"
                                clickIcon={isClickIcon}
                                disabled={true}
                            />
                            <SidemenuClose
                                icon="Setting"
                                linkTo="/setting"
                                clickIcon={isClickIcon}
                            />
                        </nav>
                    ) : (
                        <nav>
                            <MenuOne icon="Board" linkTo="/" menuName="대시보드" />
                            <MenuOne icon="Note" linkTo="/notebook" menuName="알림장" />
                            <MenuOne icon="Notice" linkTo="/notice" menuName="공지사항" disabled={true} />
                            <MenuOne icon="Photo" linkTo="/photo" menuName="앨범" disabled={true}/>
                            <DropDownMenu
                                icon="Calendar"
                                linkTo="/studentAttendance"
                                menuName="출석부"
                                subMenuName={[
                                    { name: "일간 출석부", link: "/studentAttendance/daily" },
                                    { name: "월간 출석부", link: "/studentAttendance/monthly" },
                                    { name: "출석부 설정", link: "/studentAttendance/schoolTime", disabled: user.role !== ROLE_DIRECTOR },
                                ]}
                            />
                            <MenuOne icon="List" linkTo="/list" menuName="일정표" disabled={true}/>
                            <DropDownMenu
                                icon="Bus"
                                linkTo="/schoolBus"
                                menuName="안심통학버스"
                                subMenuName={[
                                    { name: "차량 관리", link: "/schoolBus/bus" },
                                    // { name: "운행 정보", link: "/schoolBus/busSchedule" },
                                    // { name: "실시간 운행위치", link: "/schoolBus/realTimeLocation" },
                                    ]}
                                disabled={true}
                            />
                            <MenuOne icon="Bread" linkTo="/bread" menuName="식단표" disabled={true} />
                            <MenuOne icon="Temperature" linkTo="/temperature" menuName="온도 기록" disabled={true} />
                            <MenuOne icon="Medicine" linkTo="/medicine" menuName="투약 의뢰서" disabled={true} />
                            <MenuOne icon="Home" linkTo="/home" menuName="귀가 동의서" disabled={true} />
                            <DropDownMenu
                                icon="Money"
                                linkTo="/receipt"
                                menuName="수납 관리"
                                subMenuName={[
                                    { name: "수납 항목 관리", link: "/receipt/type" },
                                    { name: "수납 이력", link: "/receipt/payment" },
                                ]}
                                disabled={true}
                            />
                            <DropDownMenu
                                icon="Setting"
                                linkTo="/setting"
                                menuName="관리"
                                subMenuName={[
                                    { name: "학교 기본정보", link: "/setting/siteInformation" },
                                    { name: "DDNS 정보", link: "/setting/ddnsInformation", disabled: user.role !== ROLE_DIRECTOR },
                                    { name: "반 관리", link: "/setting/classManagement" },
                                    { name: "선생님 관리", link: "/setting/teacherManagement", disabled: user.role !== ROLE_DIRECTOR },
                                    { name: "학생 관리", link: "/setting/studentManagement" },
                                    { name: "학부모 정보", link: "/setting/parentManagement", disabled: user.role !== ROLE_DIRECTOR },
                                    { name: "전자 출결", link: "/setting/attendance", disabled: user.role !== ROLE_DIRECTOR },
                                ]}
                                disabled={false}
                            />
                        </nav>
                    )}
                </article>
                <AppVersion>
                    <Version>
                        <p>v.{VERSION}</p>
                    </Version>
                    {!isSideMenuClose &&
                        <>
                            <div>
                                <OutlinePrimaryBtn onClick={() => setIsClickDownload(prev => !prev)}>앱 다운로드</OutlinePrimaryBtn>
                            </div>
                            {isClickDownload && 
                                <DownLoadAppBtnWrap className="download-btn-wrap">
                                    <SolidPrimarySubBtn onClick={() => openModal("Google Play")} style={{width: '100%'}}>구글스토어</SolidPrimarySubBtn>
                                    <SolidPrimarySubBtn onClick={() => openModal("App Store")} style={{width: '100%'}}>앱스토어</SolidPrimarySubBtn>
                                </DownLoadAppBtnWrap>
                            }
                        </>
                    }
                </AppVersion>
            </section>
            {/* 사이드메뉴 펼침/접음 버튼 */}
            <section onClick={() => setIsSideMenuClose((prev) => !prev)}>
                {!isSideMenuClose ? <img src="/image/icon/handle-default.svg" alt="handle-default" />
                    : <img src="/image/icon/handle-open.svg" alt="handle-open" />
                }
            </section>

            <MiniModalComponent
                isOpen={modalProps.isOpen}
                isClose={modalProps.isClose}
                content={shortModalContent()}
                title={modalProps.title}
            />
        </SidemenuContainer>
    );
}

export default SideMenu;
